"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIVE_CHATS = void 0;
const LIVE_CHATS = exports.LIVE_CHATS = {
  zendesk: 'Zendesk',
  tawk: 'Tawk',
  freshchat: 'Freshchat'
};

// describes the JSONB column "chat_bubble" of the table "facebook_pages"